import { useEffect } from 'react'
import { useReactFlow } from 'reactflow'

const Resizer = (): null => {
  const reactFlowInstance = useReactFlow()

  useEffect(() => {
    function fitToScreen() {
      const container = document.querySelector('.react-flow')
      if (container) reactFlowInstance.fitView({ includeHiddenNodes: true, padding: 0.1 })
    }

    window.addEventListener('resize', fitToScreen)

    return () => {
      window.removeEventListener('resize', fitToScreen)
    }
  }, [reactFlowInstance])

  return null
}

export default Resizer
